export default __webpack_public_path__ + "static/media/promo.07b7c9c8.png";